import { render, staticRenderFns } from "./ActivationBriefProductsView.vue?vue&type=template&id=267b0913&"
import script from "./ActivationBriefProductsView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefProductsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports